/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTeamCommand
 */
export interface UpdateTeamCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamCommand
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamCommand
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UpdateTeamCommand interface.
 */
export function instanceOfUpdateTeamCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateTeamCommandFromJSON(json: any): UpdateTeamCommand {
    return UpdateTeamCommandFromJSONTyped(json, false);
}

export function UpdateTeamCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function UpdateTeamCommandToJSON(value?: UpdateTeamCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

